import './App.css';
import Dashome from './components/Dashome';
import { useEffect } from 'react';
import { Route, Routes, useNavigate, Navigate } from 'react-router-dom';
import Login from './components/login';
import ForgetPassword from './components/forgetpassword';
import ResetPassword from './components/resetpassword';
import VerifyOTP from './components/verifyotp';

function App() {

  const navigate = useNavigate();

  // 🔥 AUTO LOGOUT (INACTIVITY)
  useEffect(() => {
    let timer;

    const logout = () => {
      sessionStorage.clear();
      navigate("/");
    };

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(logout, 15 * 60 * 1000); // 15 minutes
    };

    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keypress", resetTimer);
    window.addEventListener("click", resetTimer);
    window.addEventListener("scroll", resetTimer);

    resetTimer();

    return () => {
      clearTimeout(timer);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keypress", resetTimer);
      window.removeEventListener("click", resetTimer);
      window.removeEventListener("scroll", resetTimer);
    };
  }, [navigate]);

  // 🔒 PROTECTED ROUTE
  const PrivateRoute = ({ children }) => {
    const token = sessionStorage.getItem("token");
    return token ? children : <Navigate to="/" />;
  };

  return (
    <Routes>
      <Route path='/' element={<Login />} />

      <Route 
        path='/dashboard/*' 
        element={
       <PrivateRoute>
<Dashome />
       </PrivateRoute>
            
        } 
      />

      <Route path="/forget-password" element={<ForgetPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/verify-otp" element={<VerifyOTP />} />
    </Routes>
  );
}

export default App;